import React from "react";
import EatWithMeText from "../../components/EatWIthMeText";
import MenuItemHeader from "../../components/MenuItemHeader";
import ChangeLanguage from "../../components/icon-buttons/ChangeLanguage";
import { I18n } from "react-redux-i18n";
import UserImageButton from "../../components/icon-buttons/UserImageButton";
import AbstractMenuItem from "../../components/AbstractMenuItem";
import { connect } from "react-redux";
import { get, confirmDialog } from "../../js/auth";
import { getUsersByFilter, getUsersContaining, getEntitiesContaining, modifyCustomer, addCustomer, deleteCustomer, deleteRole, addNewRole } from "../../js/superadmin/superadmin";
import admin from "../../js/admin";

class SuperUserAdmin extends AbstractMenuItem {
  state = {
    users: [],
    filteredUsers: [],
    displayedUsers: [],
    currentPage: 1,
    itemsPerPage: 20,
    totalUsers: 0,
    loading: false,
    selectedUser: null,
    labels: [],
    expandedUsers: new Set(), // Track which users are expanded
    filters: {
      nameFilter: "",
      onlineFilter: "",
      activeFilter: "true",
      roleFilter: "admin",
      entityTypeFilter: "Restaurant",
      entityFilter: ""
    },
    showEditModal: false,
    showRoleModal: false,
    editingUser: null,
    modalData: {
      id: "",
      name: "",
      surname: "",
      email: "",
      password: "",
      gitlabSecureToken: "",
      active: true,
      labels: [],
      role: "admin",
      users: [],
      entityType: "Restaurant",
      entity: []
    },
    userSearchTerm: "",
    entitySearchTerm: "",
    availableUsers: [],
    availableEntities: []
  };

  componentDidMount() {
    //this.loadUsers();
    this.loadLabels();
    this.loadFiltersFromStorage();
  }

  loadFiltersFromStorage = () => {
    const saved = localStorage.getItem('superadmin_users_filters');
    if (saved) {
      this.setState({ filters: JSON.parse(saved) }, () => {
        this.loadUsers();
      });
    }
  };

  saveFiltersToStorage = () => {
    localStorage.setItem('superadmin_users_filters', JSON.stringify(this.state.filters));
  };

  loadUsers = () => {
    this.setState({ loading: true });
    const { filters, currentPage, itemsPerPage } = this.state;
    const entityFilter = filters.entityFilter || "*";
    
    // Debug: Log the exact values being sent
    const params = {
      nameFilter: filters.nameFilter || "",
      onlineFilter: filters.onlineFilter || "",
      activeFilter: filters.activeFilter === "" ? "" : (filters.activeFilter || ""),
      roleFilter: filters.roleFilter || "",
      entityTypeFilter: filters.entityTypeFilter || "",
      entityFilter: entityFilter,
      page: Math.max(0, currentPage - 1),
      size: itemsPerPage
    };
    
    console.log("Sending parameters:", params);
    
    // Call getUsersByFilter with pagination parameters
    getUsersByFilter(
      params.nameFilter,
      params.onlineFilter,
      params.activeFilter,
      params.roleFilter || null,
      params.entityTypeFilter,
      params.entityFilter,
      params.page,
      params.size,
      (response) => {
        console.log("Success response:", response);
        this.handleUsersLoaded(response);
      },
      (error) => {
        console.error("getUsersByFilter error:", error);
        this.setState({ loading: false });
      }
    );
  };

    handleUsersLoaded = (response) => {
    // Handle standard Spring Boot pagination response format
    let users, totalUsers;
    
    if (Array.isArray(response)) {
      // Legacy format: simple array
      users = response;
      totalUsers = response.length;
    } else if (response.content) {
      // Standard Spring Boot pagination format
      users = response.content;
      totalUsers = response.totalElements || response.total || users.length;
    } else if (response.users || response.data) {
      // Alternative pagination format
      users = response.users || response.data;
      totalUsers = response.totalUsers || response.total || users.length;
    } else {
      // Fallback
      users = [];
      totalUsers = 0;
    }
    
    users.forEach(user => {
      user.title = user.name + (user.surname ? " " + user.surname : "") + " (" + user.email + ")";
      user.subprofiles = user.children?.length || 0;
      if (!user.isActive) user.extraClasses = "itemDeactivated";
      if (user.children) {
        user.children = user.children.filter(child => child.role !== "eatwithme");
        user.children.forEach(child => {
          child.title = child.role;
          // Use unique key for each role instance
          child.key = child.id ? `role:${child.id}` : `role:${user.id}:${child.role}`;
        });
      }
    });

    this.setState({ 
      users,
      displayedUsers: users, // For server-side pagination, displayed users = users
      loading: false,
      totalUsers
    });
  };

  loadLabels = () => {
    admin.getLabels((data) => {
      this.setState({ labels: data });
    });
  };

  applyPagination = () => {
    // With server-side pagination, we reload data instead of slicing client data
    this.loadUsers();
  };

  handleFilterChange = (filterName, value) => {
    this.setState({
      filters: { ...this.state.filters, [filterName]: value },
      currentPage: 1
    }, () => {
      this.saveFiltersToStorage();
      this.loadUsers();
    });
  };

  toggleUserExpanded = (userId) => {
    const { expandedUsers } = this.state;
    const newExpandedUsers = new Set(expandedUsers);
    
    if (newExpandedUsers.has(userId)) {
      newExpandedUsers.delete(userId);
    } else {
      newExpandedUsers.add(userId);
    }
    
    this.setState({ expandedUsers: newExpandedUsers });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.loadUsers);
  };

  handleItemsPerPageChange = (newItemsPerPage) => {
    this.setState({ 
      itemsPerPage: parseInt(newItemsPerPage),
      currentPage: 1 
    }, this.loadUsers);
  };

  handleUserSelect = (user) => {
    this.setState({ selectedUser: user });
  };

  openEditModal = (user = null) => {
    if (user) {
      this.setState({
        showEditModal: true,
        editingUser: user,
        modalData: {
          id: user.id,
          name: user.name,
          surname: user.surname,
          email: user.email,
          password: "",
          gitlabSecureToken: user.gitlabSecureToken || "",
          active: user.isActive,
          labels: user.labels || []
        }
      });
    } else {
      this.setState({
        showEditModal: true,
        editingUser: null,
        modalData: {
          id: "",
          name: "",
          surname: "",
          email: "",
          password: "",
          gitlabSecureToken: "",
          active: true,
          labels: []
        }
      });
    }
  };

  openRoleModal = (user) => {
    this.setState({
      showRoleModal: true,
      modalData: {
        ...this.state.modalData,
        users: [{ email: user.email, name: user.name, surname: user.surname }],
        role: "admin",
        entityType: "Restaurant",
        entity: []
      },
      userSearchTerm: "",
      entitySearchTerm: "",
      availableUsers: [],
      availableEntities: []
    });
  };

  searchUsers = (searchTerm) => {
    if (searchTerm.length >= 3) {
      // Don't escape the search term
      const unescapedSearchTerm = decodeURIComponent(searchTerm);
      getUsersContaining(unescapedSearchTerm, (data) => {
        this.setState({ availableUsers: data });
      });
    } else {
      this.setState({ availableUsers: [] });
    }
  };

  searchEntities = (entityType, searchTerm) => {
    if (searchTerm.length >= 3 && entityType) {
      // Don't escape the search term
      const unescapedSearchTerm = decodeURIComponent(searchTerm);
      
      if (entityType === "Restaurant") {
        // Use the restaurants endpoint for restaurant searches
        get(`superadminService/getRestaurantsContaining?contains=${encodeURIComponent(unescapedSearchTerm)}`, localStorage.id)
          .done((data) => {
            if (!data.error) {
              // Ensure each entity has required properties
              const entities = data.map(entity => ({
                id: entity.id,
                name: entity.name || 'Unnamed Restaurant',
                address: entity.address || ''
              }));
              this.setState({ availableEntities: entities });
            } else {
              console.warn('Restaurant search failed or returned no results:', data);
              this.setState({ availableEntities: [] });
            }
          })
          .fail((error) => {
            console.error('Restaurant search error:', error);
            this.setState({ availableEntities: [] });
          });
      } else {
        // Use the generic entities endpoint for other entity types
        getEntitiesContaining(entityType, unescapedSearchTerm, (data) => {
          this.setState({ availableEntities: data });
        });
      }
    } else {
      this.setState({ availableEntities: [] });
    }
  };

  addUserToRole = (user) => {
    const { modalData } = this.state;
    const userExists = modalData.users.find(u => u.email === user.email);
    if (!userExists) {
      this.setState({
        modalData: {
          ...modalData,
          users: [...modalData.users, user]
        },
        userSearchTerm: "",
        availableUsers: []
      });
    }
  };

  removeUserFromRole = (userEmail) => {
    const { modalData } = this.state;
    this.setState({
      modalData: {
        ...modalData,
        users: modalData.users.filter(u => u.email !== userEmail)
      }
    });
  };

  addEntityToRole = (entity) => {
    const { modalData } = this.state;
    const entityExists = modalData.entity.find(e => e.id === entity.id);
    if (!entityExists) {
      this.setState({
        modalData: {
          ...modalData,
          entity: [...modalData.entity, entity]
        },
        entitySearchTerm: "",
        availableEntities: []
      });
    }
  };

  removeEntityFromRole = (entityId) => {
    const { modalData } = this.state;
    this.setState({
      modalData: {
        ...modalData,
        entity: modalData.entity.filter(e => e.id !== entityId)
      }
    });
  };

  handleEntityTypeChange = (entityType) => {
    this.setState({
      modalData: {
        ...this.state.modalData,
        entityType: entityType,
        entity: [] // Clear entities when type changes
      },
      availableEntities: [],
      entitySearchTerm: ""
    });
  };

  closeModal = () => {
    this.setState({
      showEditModal: false,
      showRoleModal: false,
      editingUser: null
    });
  };

  saveUser = () => {
    const { modalData, editingUser } = this.state;
    
    if (editingUser) {
      modifyCustomer(
        modalData.id,
        modalData.name,
        modalData.surname,
        modalData.email,
        modalData.password,
        modalData.gitlabSecureToken,
        modalData.labels,
        modalData.active,
        () => {
          this.loadUsers();
          this.closeModal();
        }
      );
    } else {
      addCustomer(
        modalData.name,
        modalData.surname,
        modalData.email,
        modalData.password,
        modalData.gitlabSecureToken,
        modalData.labels,
        modalData.active,
        () => {
          this.loadUsers();
          this.closeModal();
        }
      );
    }
  };

  saveRole = () => {
    const { modalData } = this.state;
    
    modalData.users.forEach(user => {
      if (modalData.role === "eatwithme" || modalData.entityType === "") {
        addNewRole(user.email, modalData.role, "", 0, () => {
          this.loadUsers();
          this.closeModal();
        });
      } else {
        modalData.entity.forEach(entity => {
          addNewRole(user.email, modalData.role, modalData.entityType, entity.id, () => {
            this.loadUsers();
            this.closeModal();
          });
        });
      }
    });
  };

  deleteUserOrRole = (user) => {
    // If selected item is a role (has parent and key starts with 'role:'), delete the role
    if (user && user.parent && user.key && user.key.startsWith('role:')) {
      confirmDialog(
        I18n.t("local.confirmation"),
        I18n.t("admin_local.delete_role_confirm", user.title)
      ).done((confirmed) => {
        deleteRole(user.id.replace('role:', ''), () => {
          this.loadUsers();
        });
      });
    } else {
      // Otherwise, delete the user
      const displayName = user.name + (user.surname ? " " + user.surname : "") + " (" + user.email + ")";
      confirmDialog(
        I18n.t("local.confirmation"),
        I18n.t("admin_local.delete_user_confirm", displayName)
      ).done((confirmed) => {
        deleteCustomer(user.id, () => {
          this.loadUsers();
        });
      });
    }
  };

  activateUser = (user, active) => {
    modifyCustomer(
      user.id,
      user.name,
      user.surname,
      user.email,
      null,
      null,
      user.labels || [],
      active,
      () => {
        this.loadUsers();
      }
    );
  };

  renderPagination = () => {
    const { currentPage, itemsPerPage, totalUsers } = this.state;
    const totalPages = Math.ceil(totalUsers / itemsPerPage);
    
    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          <span>{I18n.t("admin_local.superadmin.show")}: </span>
          <select
            className="form-control d-inline-block"
            style={{ width: 'auto' }}
            value={itemsPerPage}
            onChange={(e) => this.handleItemsPerPageChange(e.target.value)}
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span className="ml-2">{I18n.t("admin_local.superadmin.entries")}</span>
        </div>
        
        <div>
          <span>
            {I18n.t("admin_local.superadmin.showing")} {((currentPage - 1) * itemsPerPage) + 1} {I18n.t("admin_local.superadmin.to")} {Math.min(currentPage * itemsPerPage, totalUsers)} {I18n.t("admin_local.superadmin.of")} {totalUsers} {I18n.t("admin_local.superadmin.entries")}
          </span>
        </div>
        
        <div>
          <nav>
            <ul className="pagination mb-0">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button 
                  className="page-link" 
                  onClick={() => this.handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  {I18n.t("admin_local.superadmin.previous")}
                </button>
              </li>
              
              {[...Array(totalPages)].map((_, index) => {
                const pageNum = index + 1;
                const showPage = pageNum === 1 || pageNum === totalPages || 
                               (pageNum >= currentPage - 2 && pageNum <= currentPage + 2);
                
                if (!showPage && pageNum === currentPage - 3) {
                  return <li key={pageNum} className="page-item disabled"><span className="page-link">...</span></li>;
                }
                if (!showPage && pageNum === currentPage + 3) {
                  return <li key={pageNum} className="page-item disabled"><span className="page-link">...</span></li>;
                }
                if (!showPage) return null;
                
                return (
                  <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button 
                      className="page-link" 
                      onClick={() => this.handlePageChange(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                );
              })}
              
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button 
                  className="page-link" 
                  onClick={() => this.handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  {I18n.t("admin_local.superadmin.next")}
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  };

  render() {
    const { myStatus, roles } = this.props;
    const { 
      displayedUsers, 
      loading, 
      selectedUser, 
      filters, 
      showEditModal, 
      showRoleModal, 
      modalData,
      editingUser,
      userSearchTerm,
      entitySearchTerm,
      availableUsers,
      availableEntities,
      expandedUsers
    } = this.state;

    if (!myStatus || !myStatus.restaurant_id) return null;

    return (
      <div style={{ display: "flex", flexFlow: "column", flexGrow: 1, height: "100vh" }}>
        <div
          className="menuItemHeader"
          style={{ 
            flexShrink: 0, 
            display: "flex", 
            flexFlow: "row", 
            width: "100%", 
            alignItems: "center", 
            height: "50px", 
            justifyContent: "space-between", 
            paddingRight: "30px" 
          }}
        >
          <EatWithMeText />
          <MenuItemHeader {...this.props} header={I18n.t("admin_local.menus.users")} />
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <ChangeLanguage />
            <UserImageButton />
          </div>
        </div>

        <div className="container-fluid" style={{ padding: "10px", flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <div className="card" style={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
            <div className="card-body d-flex flex-column" style={{ minHeight: 0, flexGrow: 1 }}>
              {/* Action Buttons */}
              <div className="btn-toolbar justify-content-between mb-3 flex-shrink-0">
                <div className="btn-group">
                  <button 
                    className="btn btn-primary"
                    onClick={() => this.openEditModal()}
                  >
                    {I18n.t("admin_local.superadmin.add_user")}
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => this.openEditModal(selectedUser)}
                    disabled={!selectedUser || selectedUser.role}
                  >
                    {I18n.t("admin_local.superadmin.edit_user")}
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => this.activateUser(selectedUser, true)}
                    disabled={!selectedUser || selectedUser.role || selectedUser.isActive}
                  >
                    {I18n.t("admin_local.superadmin.activate_user")}
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => this.activateUser(selectedUser, false)}
                    disabled={!selectedUser || selectedUser.role || !selectedUser.isActive}
                  >
                    {I18n.t("admin_local.superadmin.deactivate_user")}
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => this.openRoleModal(selectedUser)}
                    disabled={!selectedUser || selectedUser.role}
                  >
                    {I18n.t("admin_local.superadmin.add_role")}
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => this.deleteUserOrRole(selectedUser)}
                    disabled={!selectedUser}
                  >
                    {I18n.t("admin_local.superadmin.delete")}
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => get(`mautic/${localStorage.restaurantSelected}/contacts/sync`)}
                  >
                    {I18n.t("admin_local.superadmin.sync_to_mautic")}
                  </button>
                  <button 
                    className="btn btn-secondary"
                    onClick={() => {
                      const { users, expandedUsers } = this.state;
                      const allExpanded = users.every(user => expandedUsers.has(user.id));
                      if (allExpanded) {
                        this.setState({ expandedUsers: new Set() });
                      } else {
                        this.setState({ expandedUsers: new Set(users.map(user => user.id)) });
                      }
                    }}
                  >
                    {expandedUsers.size === 0 ? 'Expand All' : 'Collapse All'}
                  </button>
                </div>
              </div>

              {/* Users Table */}
              <div 
                className="table-responsive flex-grow-1" 
                style={{ 
                  overflowY: "auto", 
                  border: "1px solid #dee2e6",
                  marginBottom: "20px",
                  minHeight: 0
                }}
              >
                <table className="table table-striped">
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 10 }}>
                    <tr>
                      <th>{I18n.t("admin_local.superadmin.user")}</th>
                      <th>{I18n.t("admin_local.superadmin.online")}</th>
                      <th>{I18n.t("admin_local.superadmin.active")}</th>
                      <th>{I18n.t("admin_local.superadmin.role")}</th>
                      <th>{I18n.t("admin_local.superadmin.entity_type")}</th>
                      <th>{I18n.t("admin_local.superadmin.entity")}</th>
                    </tr>
                    <tr style={{ position: "sticky", top: "40px", backgroundColor: "#f8f9fa", zIndex: 9 }}>
                      <th>
                        <input
                          type="text"
                          className="form-control"
                          value={filters.nameFilter}
                          onChange={(e) => this.handleFilterChange('nameFilter', e.target.value)}
                          placeholder="Filter by name..."
                        />
                      </th>
                      <th>
                        <select
                          className="form-control"
                          value={filters.onlineFilter}
                          onChange={(e) => this.handleFilterChange('onlineFilter', e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="true">Online</option>
                          <option value="false">Offline</option>
                        </select>
                      </th>
                      <th>
                        <select
                          className="form-control"
                          value={filters.activeFilter}
                          onChange={(e) => this.handleFilterChange('activeFilter', e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="true">Active</option>
                          <option value="false">Deactivated</option>
                        </select>
                      </th>
                      <th>
                        <select
                          className="form-control"
                          value={filters.roleFilter}
                          onChange={(e) => this.handleFilterChange('roleFilter', e.target.value)}
                        >
                          <option value="">{I18n.t("admin_local.superadmin.all")}</option>
                          <option value="admin">{I18n.t("admin_local.role_names.admin", { defaultValue: "Admin" })}</option>
                          <option value="tester">{I18n.t("admin_local.role_names.tester", { defaultValue: "Tester" })}</option>
                          <option value="waiter">{I18n.t("admin_local.role_names.waiter", { defaultValue: "Waiter" })}</option>
                          <option value="finance">{I18n.t("admin_local.role_names.finance", { defaultValue: "Finance" })}</option>
                          <option value="store">{I18n.t("admin_local.role_names.store", { defaultValue: "Inventory" })}</option>
                          <option value="courier">{I18n.t("admin_local.role_names.courier", { defaultValue: "Courier" })}</option>
                        </select>
                      </th>
                      <th>
                        <select
                          className="form-control"
                          value={filters.entityTypeFilter}
                          onChange={(e) => this.handleFilterChange('entityTypeFilter', e.target.value)}
                        >
                          <option value="Restaurant">{I18n.t("admin_local.superadmin.restaurant")}</option>
                          <option value="">{I18n.t("admin_local.superadmin.none")}</option>
                        </select>
                      </th>
                      <th>
                        <input
                          type="text"
                          className="form-control"
                          value={filters.entityFilter}
                          onChange={(e) => this.handleFilterChange('entityFilter', e.target.value)}
                          placeholder={I18n.t("admin_local.superadmin.filter_by_entity")}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" className="text-center">{I18n.t("admin_local.superadmin.loading")}</td>
                      </tr>
                    ) : displayedUsers.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">{I18n.t("admin_local.superadmin.no_users_found")}</td>
                      </tr>
                    ) : (
                      displayedUsers.map((user) => (
                        <React.Fragment key={user.id}>
                          <tr 
                            className={`${user.extraClasses || ''} ${selectedUser?.id === user.id ? 'table-primary' : ''}`}
                            onClick={() => this.handleUserSelect(user)}
                            style={{ cursor: 'pointer' }}
                          >
                            <td>
                              <button
                                className="btn btn-sm btn-link p-0 me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.toggleUserExpanded(user.id);
                                }}
                                style={{ textDecoration: 'none', border: 'none', background: 'none' }}
                              >
                                {expandedUsers.has(user.id) ? '▼' : '▶'}
                              </button>
                              {user.title}
                            </td>
                            <td>{I18n.t(`admin_local.superadmin.${user.isOnline ? 'yes' : 'no'}`)}</td>
                            <td>{I18n.t(`admin_local.superadmin.${user.isActive ? 'yes' : 'no'}`)}</td>
                            <td>{
                              user.children?.reduce((acc, child) => {
                                const existingRole = acc.find(r => r.role === child.role);
                                if (existingRole) {
                                  existingRole.count++;
                                } else {
                                  acc.push({ role: child.role, count: 1 });
                                }
                                return acc;
                              }, []).map(r => `${r.role}(${r.count})`).join(', ') || ''
                            }</td>
                            <td></td>
                            <td></td>
                          </tr>
                          {expandedUsers.has(user.id) && user.children?.map((child) => (
                            <tr 
                              key={child.key}
                              className={selectedUser?.id === child.key ? 'table-primary' : ''}
                              onClick={() => this.handleUserSelect({ ...child, id: child.key, parent: user })}
                              style={{ cursor: 'pointer', paddingLeft: '20px' }}
                            >
                            <td style={{ paddingLeft: '20px' }}>↳ {child.title}</td>
                            <td></td>
                            <td></td>
                            <td>{I18n.t(`admin_local.role_names.${child.role}`, { defaultValue: child.role })}</td>
                            <td>{child.entityType || 'None'}</td>
                            <td>{child.entity?.name}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex-shrink-0 mt-3">
                {this.renderPagination()}
              </div>
            </div>
          </div>
        </div>

        {/* Edit User Modal */}
        {showEditModal && (
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {I18n.t(editingUser ? "admin_local.superadmin.edit_user_title" : "admin_local.superadmin.add_user_title")}
                  </h5>
                  <button type="button" className="close" onClick={this.closeModal}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.name")}</label>
                      <input
                        type="text"
                        className="form-control"
                        value={modalData.name}
                        onChange={(e) => this.setState({
                          modalData: { ...modalData, name: e.target.value }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.surname")}</label>
                      <input
                        type="text"
                        className="form-control"
                        value={modalData.surname}
                        onChange={(e) => this.setState({
                          modalData: { ...modalData, surname: e.target.value }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.email")}</label>
                      <input
                        type="email"
                        className="form-control"
                        value={modalData.email}
                        onChange={(e) => this.setState({
                          modalData: { ...modalData, email: e.target.value }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.password")}</label>
                      <input
                        type="password"
                        className="form-control"
                        value={modalData.password}
                        onChange={(e) => this.setState({
                          modalData: { ...modalData, password: e.target.value }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.gitlab_secure_token")}</label>
                      <input
                        type="text"
                        className="form-control"
                        value={modalData.gitlabSecureToken}
                        onChange={(e) => this.setState({
                          modalData: { ...modalData, gitlabSecureToken: e.target.value }
                        })}
                      />
                    </div>
                    <div className="form-group">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={modalData.active}
                          onChange={(e) => this.setState({
                            modalData: { ...modalData, active: e.target.checked }
                          })}
                        />
                        <label className="form-check-label">{I18n.t("admin_local.superadmin.active")}</label>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                    {I18n.t("admin_local.superadmin.close")}
                  </button>
                  <button type="button" className="btn btn-primary" onClick={this.saveUser}>
                    {I18n.t("admin_local.superadmin.save")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Add Role Modal */}
        {showRoleModal && (
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{I18n.t("admin_local.superadmin.role_editor")}</h5>
                  <button type="button" className="close" onClick={this.closeModal}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.role")}</label>
                      <select
                        className="form-control"
                        value={modalData.role}
                        onChange={(e) => this.setState({
                          modalData: { ...modalData, role: e.target.value }
                        })}
                      >
                        {(roles || []).map(role => (
                          <option key={role} value={role}>
                            {I18n.t(`admin_local.role_names.${role}`, { defaultValue: role })}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.users")}</label>
                      <div className="border rounded p-2" style={{ minHeight: '38px', backgroundColor: '#fff' }}>
                        {modalData.users.map(user => (
                          <span key={user.email} className="badge badge-primary mr-1 mb-1" style={{ cursor: 'pointer' }}>
                            {user.name}{user.surname ? ` ${user.surname}` : ''} ({user.email})
                            <button
                              type="button"
                              className="close ml-1"
                              style={{ fontSize: '0.8em', color: 'white' }}
                              onClick={() => this.removeUserFromRole(user.email)}
                            >
                              ×
                            </button>
                          </span>
                        ))}
                        <input
                          type="text"
                          className="form-control border-0 d-inline"
                          style={{ width: 'auto', minWidth: '200px', boxShadow: 'none' }}
                          value={userSearchTerm}
                          onChange={(e) => {
                            this.setState({ userSearchTerm: e.target.value });
                            this.searchUsers(e.target.value);
                          }}
                          placeholder={I18n.t("admin_local.superadmin.filter_by_name")}
                        />
                      </div>
                      {availableUsers.length > 0 && (
                        <div className="dropdown-menu show" style={{ position: 'relative', width: '100%', marginTop: '2px' }}>
                          {availableUsers.map(user => (
                            <button
                              key={user.email}
                              type="button"
                              className="dropdown-item"
                              onClick={() => this.addUserToRole(user)}
                            >
                              {user.name}{user.surname ? ` ${user.surname}` : ''} ({user.email})
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.entity_type")}</label>
                      <select
                        className="form-control"
                        value={modalData.entityType}
                        onChange={(e) => this.handleEntityTypeChange(e.target.value)}
                      >
                        <option value="Restaurant">{I18n.t("admin_local.superadmin.restaurant")}</option>
                        <option value="">{I18n.t("admin_local.superadmin.none")}</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>{I18n.t("admin_local.superadmin.entities")}</label>
                      <div className="border rounded p-2" style={{ minHeight: '38px', backgroundColor: '#fff' }}>
                        {modalData.entity.map(entity => (
                          <span key={entity.id} className="badge badge-success mr-1 mb-1" style={{ cursor: 'pointer' }}>
                            {entity.name}{entity.address ? ` (${entity.address})` : ''}
                            <button
                              type="button"
                              className="close ml-1"
                              style={{ fontSize: '0.8em', color: 'white' }}
                              onClick={() => this.removeEntityFromRole(entity.id)}
                            >
                              ×
                            </button>
                          </span>
                        ))}
                        {modalData.entityType && (
                          <input
                            type="text"
                            className="form-control border-0 d-inline"
                            style={{ width: 'auto', minWidth: '200px', boxShadow: 'none' }}
                            value={entitySearchTerm}
                            onChange={(e) => {
                              this.setState({ entitySearchTerm: e.target.value });
                              this.searchEntities(modalData.entityType, e.target.value);
                            }}
                            placeholder={I18n.t("admin_local.superadmin.filter_by_entity")}
                          />
                        )}
                      </div>
                      {availableEntities.length > 0 && (
                        <div className="dropdown-menu show" style={{ position: 'relative', width: '100%', marginTop: '2px' }}>
                          {availableEntities.map(entity => (
                            <button
                              key={entity.id}
                              type="button"
                              className="dropdown-item"
                              onClick={() => this.addEntityToRole(entity)}
                            >
                              {entity.name}{entity.address ? ` (${entity.address})` : ''}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                    {I18n.t("admin_local.superadmin.close")}
                  </button>
                  <button type="button" className="btn btn-primary" onClick={this.saveRole}>
                    {I18n.t("admin_local.superadmin.save")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Backdrop */}
        {(showEditModal || showRoleModal) && (
          <div className="modal-backdrop show" onClick={this.closeModal}></div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      restaurant: props.rootReducer.restaurant,
      myStatus: props.rootReducer.myStatus,
      local: props.rootReducer.local,
      admin_local: props.rootReducer.admin_local,
      roles: (props.rootReducer?.rbac?._roles && Object.keys(props.rootReducer.rbac._roles)) || []
    };
  }
  return {};
};

export default connect(mapStateToProps)(SuperUserAdmin);
